import { Injectable } from '@angular/core';
import {
  MatchDayOption,
  SummaryOperationResponse,
  SummaryStatusResponse,
} from '../models/round-summary.model';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class RoundSummariesService {
  constructor(private apiService: ApiService) {}

  getMatchDays(): Promise<MatchDayOption[]> {
    return this.apiService.request<MatchDayOption[]>('/match-days', 'GET');
  }

  getLatestMatchDay(): Promise<SummaryStatusResponse> {
    return this.apiService.request<SummaryStatusResponse>(
      '/match-days/summaries/latest',
      'GET',
    );
  }

  getStatus(
    type: 'round' | 'match_day',
    id: string,
    groupId?: string,
  ): Promise<SummaryStatusResponse> {
    const query =
      type === 'match_day' && groupId
        ? `?groupId=${encodeURIComponent(groupId)}`
        : '';
    return this.apiService.request<SummaryStatusResponse>(
      `${this.getBasePath(type, id)}/status${query}`,
      'GET',
    );
  }

  generate(
    type: 'round' | 'match_day',
    id: string,
    force = false,
    groupId?: string,
  ): Promise<SummaryOperationResponse> {
    return this.apiService.request<SummaryOperationResponse>(
      `${this.getBasePath(type, id)}/generate`,
      'POST',
      { force, groupId },
    );
  }

  send(
    type: 'round' | 'match_day',
    id: string,
    force = false,
    groupId?: string,
  ): Promise<SummaryOperationResponse> {
    return this.apiService.request<SummaryOperationResponse>(
      `${this.getBasePath(type, id)}/send`,
      'POST',
      { force, groupId },
    );
  }

  private getBasePath(type: 'round' | 'match_day', id: string): string {
    return type === 'round'
      ? `/rounds/${id}/summary`
      : `/match-days/${id}/summary`;
  }
}
